<div class="orcamento-mensal">
  <div class="row justify-content-center">
    <div class="col-md-6 mb-4 d-flex justify-content-center">
      <div class="d-flex align-items-center">
        <button class="btn btn-outline-primary btn-sm" (click)="mesAnterior()">
          <i class="fa fa-chevron-left"></i>
        </button>
        <h4 class="mb-0 mx-3 text-uppercase font-weight-bold" style="min-width: 150px; text-align: center;">
          {{ meses[mesAtual] }} / {{ anoAtual }}
        </h4>
        <button class="btn btn-outline-primary btn-sm" (click)="proximoMes()">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="row">
      <div class="col-md-3 mb-4">
        <div class="header-box bg-light-green">
          <div class="box-label">RENDA</div>
          <div class="box-value">{{ orcamento.renda | currency:'BRL':'symbol':'1.2-2' }}</div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="header-box bg-light-blue">
          <div class="box-label">SALDO ATUAL</div>
          <div class="box-value">{{ orcamento.saldoAtual | currency:'BRL':'symbol':'1.2-2' }}</div>
        </div>
      </div>
      <div class="col-md-6 d-flex align-items-center justify-content-end">
        <button class="btn btn-success" (click)="abrirModalNovoOrcamento()">
          <i class="fa fa-plus"></i> Novo Orçamento Despesas
        </button>
        <button class="btn btn-success" style="margin-left: 10px" (click)="abrirModalNovoOrcamentoReceita()">
          <i class="fa fa-plus"></i> Novo Orçamento Receitas
        </button>
      </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-4" *ngFor="let semana of orcamento.semanas; let i = index">
      <div class="semana-container">
        <div class="semana-header text-center">{{ semana.titulo }}</div>
        <div class="table-responsive">
          <table class="table table-bordered table-sm table-orcamento">
            <thead>
              <tr>
                <th class="bg-light-blue-table" style="width: 50%">ITEM:</th>
                <th class="bg-light-blue-table text-center">PLANEJADO (R$)</th>
                <th class="bg-light-blue-table text-center">GASTO (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of semana.itens" (click)="abrirModalDetalhe(item)" style="cursor: pointer">
                <td [ngClass]="{'text-success': item.tipo === 2, 'text-danger': item.tipo === 1}" class="bg-light-gray-table">
                  {{ item.item }}
                </td>
                <td class="bg-light-gray-table text-center" [ngClass]="{'text-success': item.tipo === 2, 'text-danger': item.tipo === 1}">
                  {{ item.planejado > 0 ? ((item.tipo === 1 ? -item.planejado : item.planejado) | currency:'BRL':'symbol':'1.2-2') : (0 | currency:'BRL':'symbol':'1.2-2') }}
                </td>
                <td class="bg-light-gray-table text-center" [ngClass]="{'text-success': item.tipo === 2, 'text-danger': item.tipo === 1}">
                  {{ item.gasto > 0 ? ((item.tipo === 1 ? -item.gasto : item.gasto) | currency:'BRL':'symbol':'1.2-2') : (0 | currency:'BRL':'symbol':'1.2-2') }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="text-right fw-bold border-0">TOTAL:</td>
                <td class="bg-dark-gray-table text-center fw-bold" [ngClass]="{'text-success': calcularTotalPlanejado(semana) >= 0, 'text-danger': calcularTotalPlanejado(semana) < 0}">
                  {{ calcularTotalPlanejado(semana) | currency:'BRL':'symbol':'1.2-2' }}
                </td>
                <td class="bg-dark-gray-table text-center fw-bold" [ngClass]="{'text-success': calcularTotalGasto(semana) >= 0, 'text-danger': calcularTotalGasto(semana) < 0}">
                  {{ calcularTotalGasto(semana) | currency:'BRL':'symbol':'1.2-2' }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<app-financeiro-modal-orcamento
  *ngIf="modalNovoOrcamento"
  [orcamento]="novoOrcamento"
  [meses]="meses"
  [tipos]="$any(tiposConta)"
  [titulo]="modoEdicao ? 'Editar Orçamento' : 'Novo Orçamento'"
  labelTipo="Tipo Conta"
  [modoEdicao]="modoEdicao"
  (fechar)="fecharModal()"
  (salvar)="salvarOrcamento()"
  (deletar)="deletarOrcamento($event)"
></app-financeiro-modal-orcamento>

<app-financeiro-modal-orcamento
  *ngIf="modalNovoOrcamentoReceita"
  [orcamento]="novoOrcamentoReceita"
  [meses]="meses"
  [tipos]="$any(tiposReceita)"
  [titulo]="modoEdicao ? 'Editar Orçamento Receitas' : 'Novo Orçamento Receitas'"
  labelTipo="Tipo Receita"
  [modoEdicao]="modoEdicao"
  (fechar)="fecharModal()"
  (salvar)="salvarOrcamentoReceita()"
  (deletar)="deletarOrcamento($event)"
></app-financeiro-modal-orcamento>
